module.exports = __webpack_public_path__ + "static/media/icon_event_time_bonus.88279b36.svg";